import { render, staticRenderFns } from "./ProfileCreateForm.vue?vue&type=template&id=12e82727"
import script from "./ProfileCreateForm.vue?vue&type=script&lang=js"
export * from "./ProfileCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports